import { render, staticRenderFns } from "./flash-tips.vue?vue&type=template&id=254916a9&scoped=true&"
import script from "./flash-tips.vue?vue&type=script&lang=js&"
export * from "./flash-tips.vue?vue&type=script&lang=js&"
import style0 from "./flash-tips.vue?vue&type=style&index=0&id=254916a9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254916a9",
  null
  
)

export default component.exports